export const classes = {
  loadMore: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '16px',
  },
}
